import React from "react";
import { Form, Input } from "@xala/common-ui";
import { useTranslation } from "react-i18next";
import { INotificationField } from "./INotificationField";

export const UrlDescriptionField = ({
  notification,
  isEditMode,
  isHidden,
}: INotificationField) => {
  const { t } = useTranslation();

  if (isHidden) {
    return null;
  }

  return (
    <Form.Item
      name="UrlDescription"
      label={t("NOTIFICATION_URL_DESCRIPTION_FIELD")}
      key="UrlDescription"
      initialValue={isEditMode ?? notification?.UrlDescription}
    >
      <Input placeholder={t("NOTIFICATION_URL_DESCRIPTION_INPUT_FIELD")} />
    </Form.Item>
  );
};
